export const formatRows = (listaItems) =>
    listaItems.map((item) => ({
      id: item.id || "Id no disponible",
      descripcion: item.theme_descripcion || "Theme no disponible",
      estado: item.theme_show_web === true ?"Activo" :"Inactivo"|| "Theme no disponible",
    }));
  